import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionQuery } from '../state/session/session.query';
import { UiQuery } from '../../shared/state/ui/ui.query';
import { AppConfigQuery } from '../state/app-config/app-config.query';
import { ImpersonateQuery } from 'src/app/pages/admin/impersonate/state/impersonate.query';

@Injectable({
    providedIn: 'root'
})
export class AutoLoginGuard implements CanActivate {
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let urlTree = null;
        // if login redirect contains a url query param (allows for deep linking)...
        if (route.queryParamMap.get('resume')) {
            // ...parse the url (create an UrlTree)
            urlTree = this.router.parseUrl(atob(route.queryParamMap.get('resume')));
        }
        return this._sessionQuery.isAuthenticated()
            ? urlTree ||
                  this.router.createUrlTree([
                      // if user is admin, redirect to admin page
                      this._sessionQuery.isAdminUser
                          ? '/admin'
                          : // if user is asset manager and not impersonating another user, redirect to impersonation page
                          this._sessionQuery.isAssetManager &&
                            !this._impersonateQuery.activeImpersonation
                          ? '/impersonation'
                          : // if user is not admin or asset manager, redirect to landing page
                            this._appConfig.appConfig.landingPageOverride || ''
                  ])
            : true;
    }
    constructor(
        private _sessionQuery: SessionQuery,
        private _impersonateQuery: ImpersonateQuery,
        private ui: UiQuery,
        private router: Router,
        private _appConfig: AppConfigQuery
    ) {}
}
